import { add, addMonths, format, getYear } from 'date-fns'
import css from './headerDropdown.module.css'
import ArrowDoubleLeft from '../../../../../assets/icons/arrowDoubleLeft.svg?react'
import ArrowDoubleRight from '../../../../../assets/icons/arrowDoubleRight.svg?react'
import ArrowLeft from '../../../../../assets/icons/arrowLeft.svg?react'
import ArrowRight from '../../../../../assets/icons/arrowRight.svg?react'

interface IProps {
  type?: 'date' | 'month' | 'quarter' | 'year'
  range?: boolean
  double?: boolean
  currentMonth: Date
  handlePrevYear: () => void
  handleNextYear: () => void
  handlePrevMonth: () => void
  handleNextMonth: () => void
  handlePrevDecade: () => void
  handleNextDecade: () => void
}

const HeaderDropdown = ({
  handleNextMonth,
  handleNextYear,
  handleNextDecade,
  handlePrevMonth,
  handlePrevYear,
  handlePrevDecade,
  currentMonth,
  double = false,
  type = 'date',
}: IProps) => {
  const secondMonth = addMonths(currentMonth, 1)

  const formatDate = (date: Date) => {
    switch (type) {
      case 'date':
        return format(date, 'LLL yyyy')
      case 'year':
        const startYear = Math.floor(getYear(date) / 10) * 10
        return `${startYear}-${startYear + 9}`
      default:
        return format(date, 'yyyy')
    }
  }

  const renderCurrentMonth = () => {
    const formattedMonths = [formatDate(currentMonth)]
    if (double) {
      const nextMonth =
        type === 'date'
          ? secondMonth
          : type === 'year'
            ? new Date(getYear(currentMonth) + 10, 0)
            : add(secondMonth, { years: 1 })

      formattedMonths.push(formatDate(nextMonth))
    }

    return formattedMonths.map((month, index) => (
      <div key={index} className={css.currentMonth}>
        {month}
      </div>
    ))
  }

  const renderArrow = (Icon: JSX.Element, onClick: () => void) => (
    <div className={css.arrow} onClick={onClick}>
      {Icon}
    </div>
  )
  return (
    <div className={css.header}>
      <div className={css.arrowButtons}>
        {renderArrow(<ArrowDoubleLeft width={12} height={12} />, type !== 'year' ? handlePrevYear : handlePrevDecade)}
        {type === 'date' && renderArrow(<ArrowLeft width={18} height={18} />, handlePrevMonth)}
      </div>
      <div className={css.containerCurrentMonths}>{renderCurrentMonth()}</div>
      <div className={css.arrowButtons}>
        {type === 'date' && renderArrow(<ArrowRight width={18} height={18} />, handleNextMonth)}
        {renderArrow(<ArrowDoubleRight />, type !== 'year' ? handleNextYear : handleNextDecade)}
      </div>
    </div>
  )
}

export default HeaderDropdown
